<template>
  <div class="container">
    <!-- <button @click="jump()">jump</button> -->
    <div class="flvf_popup_minprogress" @touchmove.prevent>
      <div class="flvf_popup_minprogress_img">
        <img class="flvf_popup_minprogress_imgi" :src="code" />
      </div>
    </div>
  </div>
</template>
<!-- guidapplet -->
<!-- agencyQrcode -->
<script>
  export default {
    data() {
      return {
        // Wap
        code:require('../../assets/images/fc/gh_54de91dcb978_344.png')
      }
    },
    created() {},
    mounted() {
      if(localStorage.getItem('source')){
        this.loading()
      }

    },
    activated() {
    },
    methods: {
      jump(){

        this.$store.commit('settestStadiums',2)
        this.$router.push({
          name:'protocol'
        })
      },
      loading(){
        var $this = this
        // this.$loading('加载中');
        let param = {
          code: localStorage.getItem("source")
        }
        var qs = require('qs');
        let url = this.api.userApi.Wap
        this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            console.log(result)
            if (result.data) {
              $this.code=result.data.url
            } else {

            }
          }).catch((error) => {

          })
      }
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .flvf_popup_minprogress{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3000;
    background: #FFFFFF;
    width: 100%;
    height: 100vh;

    background-image: url('../../assets/images/fc/bgggg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .flvf_popup_minprogress_img{
      width: 100%;
      height: 100vh;
      padding: 33.5vh 36.5% 0 33.5%;
      .flvf_popup_minprogress_imgi{
        width: 100%;
      }
    }
    .flvf_popup_minprogress_txt{
      width: 100%;
      text-align: center;
      padding: 120*@vm_base 0 60*@vm_base 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/guidapplet/guidapplet.vue